import React from 'react';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { getDate } from '../../shared/utils/date';
import { confirmedPlayerMatches } from '../../shared/utils/player-engagement';
import { timestampMillis } from '../../shared/utils/league-offer-week';

export default function RecentForm({
  matches,
  userId,
  count = 5,
}: {
  matches: Matches.Match[];
  userId: string;
  count?: number;
}) {
  const { t } = useTranslation('profile');
  const recent = confirmedPlayerMatches(matches || [], userId).slice(0, count);

  const items = recent.map(m => {
    const isChallenger = m.kul_t_id === userId;
    const own = Number(isChallenger ? m.kul_t_sonuc : m.kul_r_sonuc) || 0;
    const opp = Number(isChallenger ? m.kul_r_sonuc : m.kul_t_sonuc) || 0;
    return { played: true, won: own > opp, own, opp, time: timestampMillis(m.mac_saati) / 1000 };
  });

  const ordered = [...items].reverse();
  const slots: Array<typeof items[number] | { played: false }> = [];
  while (slots.length + ordered.length < count) slots.push({ played: false });
  slots.push(...ordered);

  return (
    <div className="recent-form" aria-label={t('recentForm.ariaLabel', { count })}>
      {slots.map((r, idx) => {
        if (!r.played) {
          return (
            <Tooltip key={idx} title={t('recentForm.notPlayedYet', { count })}>
              <span
                className="recent-form-dot recent-form-dot--empty"
                aria-label={t('recentForm.noMatch')}
              />
            </Tooltip>
          );
        }
        return (
          <Tooltip
            key={idx}
            title={`${r.won ? t('recentForm.winner') : t('recentForm.loser')} · ${r.own}-${r.opp} · ${getDate(r.time)}`}
          >
            <span
              className={`recent-form-dot ${
                r.won ? 'recent-form-dot--win' : 'recent-form-dot--loss'
              }`}
              aria-label={r.won ? t('recentForm.winner') : t('recentForm.loser')}
            >
              {r.won ? <CheckOutlined /> : <CloseOutlined />}
            </span>
          </Tooltip>
        );
      })}
    </div>
  );
}

RecentForm.defaultProps = { count: 5 };
